import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=40c527b8&scoped=true&"
import script from "./FaqSection.vue?vue&type=script&lang=js&"
export * from "./FaqSection.vue?vue&type=script&lang=js&"
import style0 from "./FaqSection.vue?vue&type=style&index=0&id=40c527b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c527b8",
  null
  
)

export default component.exports